import React, { useEffect, useState, useRef } from 'react';
import { AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Button, Col, Dropdown, DropdownMenu, DropdownToggle, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane, Tooltip, DropdownItem } from 'reactstrap';
import Backdrop from '@material-ui/core/Backdrop';
import Badge from '@material-ui/core/Badge';
import moment from 'moment';
import { grey } from '@material-ui/core/colors';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { openPopupWidget } from 'react-calendly';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import io from 'socket.io-client';
import { dismiss_msg_pop, IMPORT_FROM_LOCAL } from '../../../actions/cartAction';
import { get_comp_details_keys } from '../../../actions/dashboardAction';
import { restoreDocumentToCompany } from '../../../actions/documentAction';
import { viewProfile } from '../../../actions/myProfileAction';
import {
   categoryList,
   Clear_subs_Data,
   countryList,
   DISMIS,
   DISMIS_1,
   getSettingsData,
   getSubscriptionLists,
   listSubscription,
} from '../../../actions/subscriptionAction';
import {
   closeErrorMsg,
   getCartCount,
   getErrorMsg,
   getUserDetails,
   logOut,
   LogOutModalView,
   restoreModalView,
   setDropdownOpen,
   mobileModalFunc,
   subExpiryNotifyToggle,
   closeMouseEvent,
} from '../../../actions/uiAction';
import {
   addLoginData,
   adminUserLogin,
   authModal,
   clearFormData,
   createNewPassword,
   forgotModal,
   forgotPassword,
   getCompanyCredetials,
   newPwdModal,
   otpModal,
   otpSubmit,
   setActiveTab,
   SHow_pop_for_login,
   signInModal,
   userLogin,
} from '../../../actions/userLoginAction';
import company from '../../../images/new-design/account/company.svg';
import userIcon from '../../../images/new-design/account/mail.svg';
import name from '../../../images/new-design/account/name.svg';
import passwordIcon from '../../../images/new-design/account/password.svg';
import logo from '../../../images/new-design/site-logo.png';
import ReCAPTCHA from 'react-google-recaptcha';
// import "../../../index.css";
import LoginSignupModal from '../../../modules/Common/LoginSignupModal/LoginSignup';
import BottomModal from '../../../modules/Common/bottommodal';
import RestoreModal from '../../../modules/Common/RestoreModal';
// import './header.scss';
// import './index.css';
import './modernHeader.scss';
import { changeModal, getCount, getNotifications } from '../../../actions/notificationActions';
import { saveSignUp, popupoff, popup, OtpModal } from '../../../actions/signUpAction';
import trolly from '../../../images/new-design/cart-new.svg';
import WOW from '../../../js/wow';
import fetchData, { checkValue, NodeURL, RootdomainURL } from '../../../services';
import NotificationModal from './notificationModal';
import OneNotificationModal from './oneNotificationModal';
import SubdomainRemind from '../SubdomainRemidModal';
import MobileModal from './MobileModal';
import CONFIG from '../../../config';
import { Modal as ReactstrapModal, ModalBody } from 'reactstrap';
import { Dropdown as dropDown, MenuItem } from '@trendmicro/react-dropdown';
import SubscriptionList from '../../Subscriptions/SubscriptionList';
import Timer from './Timer';
import CloudDocDropdown from './dropDownPolicy';
import FeaturesGrid from './dropDownFeatures';
import routes from '../../../routes';
import { getBranch } from '../../../actions/userAction';
import HeaderSection from '../../Component/HeaderSection';
import CareManagementDropdown from './caremanagement';
import ResourceDropdown from './ResourceDropdown';
import TrialBanner from './TrialBanner';
// import '../DocumentAccessModal/index.css';
import './Promo.scss'
import MobileDrawer from './MobileDrawer';
let validateEmail = (email) => {
   const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   return re.test(String(email).toLowerCase());
};

const url = 'https://calendly.com/d/dpp-jhs-cxx/cloudoc-system-demo';

const pageSettings = {
   backgroundColor: 'ffffff',
   hideEventTypeDetails: false,
   hideLandingPageDetails: false,
   primaryColor: '00a2ff',
   textColor: '4d5055',
};

const prefill = {};

const utm = {
   utmCampaign: '',
   utmContent: '',
   utmMedium: '',
   utmSource: '',
   utmTerm: '',
};

const Header = (props) => {
   const dispatch = useDispatch(),
      history = useHistory(),
      authCheck = useSelector((state) => state.authentication.isAuthenticated),
      cartCount = useSelector((state) => state.UIReducer.cartCount),
      settingsData = useSelector((state) => state.subscriptionData.settingData),
      companyData = useSelector((state) => state.UIReducer.userDetails),
      myProfile = useSelector((state) => state.myProfile.addViewData),
      dropdownOpen = useSelector((state) => state.UIReducer.dropdownOpen),
      showRestoreModal = useSelector((state) => state.UIReducer.showRestoreModal),
      restoreOption = useSelector((state) => state.UIReducer.restoreOption),
      pop_show_hide = useSelector((state) => state.UIReducer.pop_show_hide),
      active_subs = useSelector((state) => state.userLoginData.active_subs),
      Comp_details = useSelector((state) => state.userLoginData.Comp_details),
      dismiss_subs = useSelector((state) => state.userLoginData.dismiss_subs),
      offline_cart_data_count = useSelector((state) => state.cartData.offline_cart_data_count),
      dismiss_comp_details = useSelector((state) => state.userLoginData.dismiss_comp_details),
      formData = useSelector((state) => state.userLoginData.formData),
      submitButton = useSelector((state) => state.button.pending),
      activeTab = useSelector((state) => state.userLoginData.activeTab),
      showLoginModal = useSelector((state) => state.userLoginData.showLoginModal),
      showForgotModal = useSelector((state) => state.userLoginData.showForgotModal),
      showOptModal = useSelector((state) => state.userLoginData.showOptModal),
      showNewPwdModal = useSelector((state) => state.userLoginData.showNewPwdModal),
      forgotUser = useSelector((state) => state.userLoginData.forgotUser),
      showMainModal = useSelector((state) => state.userLoginData.showMainModal),
      path = useSelector((state) => state.userLoginData.path),
      showError = useSelector((state) => state.UIReducer.showError),
      pop_show = useSelector((state) => state.cartData.pop_show),
      dismiss_msg = useSelector((state) => state.cartData.dismiss_msg),
      userSubscribedPlan = useSelector((state) => state.subscriptionData.userSubscribedPlan),
      docUpdateStatus = useSelector((state) => state.userLoginData.docUpdateStatus),
      showNotification = useSelector((state) => state.notificationData.showNotification),
      unReadCount = useSelector((state) => state.notificationData.unread),
      showOneNotification = useSelector((state) => state.notificationData.oneNotification),
      errorMsg = useSelector((state) => state.UIReducer.errorMessage),
      companyDetails = useSelector((state) => state.userLoginData.companyDetails),
      subdomainRemindModal = useSelector((state) => state.myProfile.subdomainRemindModal),
      sub_categoryList = useSelector((state) => state.subscriptionData.categoryList),
      licenseStatus = useSelector((state) => state.userLoginData.licenseStatus),
      countriesList = useSelector((state) => state.subscriptionData.countryList),
      // showMsg = useSelector(state => state.UIReducer.notifyModal),
      mobileModal = useSelector((state) => state.UIReducer.mobileModal);
   // showLogOutModal = useSelector(state => state.UIReducer.showLogOutModal),
   // offline_cart = useSelector(state => state.cartData.offline_cart_dat),

   const branches = useSelector((state) => state.userData.branches);

   const reRef = useRef(null);
   const [state, setState] = useState({
      showError: false,
      tooltipOpen: false,
      showInfo: false,
   });
   const [show, setShow] = useState(true);
   const [showPromo, setShowpromo] = useState(true);
   const [otpnum, setotp] = useState('');
   const [showButton, setShowButton] = useState(false);
   const [closeModal, setCloseModal] = useState(false);
   const [otpmodel, setOtpModal] = useState(false);
   const [isOpen, setIsOpen] = useState(false);
   const [isOpenPolicy, setIsOpenPolicy] = useState(false);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isModalOpenFea, setIsModalFeaOpen] = useState(false);
   const [isModalOpenCare, setIsModalCareOpen] = useState(false);
   const [isModalOpenResource, setIsModalResourceOpen] = useState(false);
   let pathname = props.location.pathname;
   const routeAccess = routes.find((i) => i.path === pathname && i.private);

   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
   const [locationDropdownOpen, setLocationDropdownOpen] = useState(false);
   const [selectedLocation, setSelectedLocation] = useState({
      id: '',
      name: 'Main Branch',
      badge: '',
   });
   const hasActiveTrial = myProfile?.allinOne?.status === 1 && myProfile?.allinOne?.planType === 'Trial';
   const trialDays = settingsData?.traildays ?? 0;
   const days = myProfile?.allinOne?.status === 1 && checkValue(myProfile.allinOne?.planExpiry)
         ? moment(myProfile?.allinOne?.planExpiry).diff(moment(new Date()), 'days')
         : null;

   const showTrialBanner = settingsData?.Trailstatus === 1 && sessionStorage.getItem('isAuthenticated') === 'true' && companyData?.allinOne?.status != 1 && companyData?.careManagement?.status != 1  ;

   // const days = (myProfile?.allinOne?.status === 1 && checkValue(myProfile.allinOne?.planExpiry)) ? moment(myProfile?.allinOne?.planExpiry).diff(moment(new Date()), 'days') : null;


   const locations = [
      {
         id: 1,
         name: 'Westminster Branch',
         badge: 'Main',
         subtitle: 'Main Location',
         clients: 245,
         staff: 42,
      },
      {
         id: 2,
         name: 'Richmond Branch',
         badge: 'Secondary',
         subtitle: 'Secondary',
         clients: 180,
         staff: 28,
      },
      {
         id: 3,
         name: 'Camden Branch',
         badge: 'Secondary',
         subtitle: 'Secondary',
         clients: 156,
         staff: 25,
      },
      {
         id: 4,
         name: 'All Locations',
         badge: 'Combined',
         subtitle: 'Combined View',
         clients: 581,
         staff: 95,
      },
   ];
   useEffect(() => {
      dispatch(getBranch());
         if (shouldShowNotification(DISMISS_SUBS_KEY)) {
      sessionStorage.removeItem('DISMIS_1');
   } else {
      dispatch(DISMIS_1());
   }
   if (shouldShowNotification(DISMISS_COMP_KEY)) {
      sessionStorage.removeItem('DISMIS');
   } else {
      dispatch(DISMIS());
   }
   }, []);
  const openCalendly = (e) => {
    e.preventDefault();
    window.Calendly.initPopupWidget({
      url: 'https://calendly.com/d/dpp-jhs-cxx/cloudoc-policies-documents-system-demo',
    });
  };
   useEffect(() => {
      // Function to check sidebar state
      const checkSidebarState = () => {
         // Method 1: Check sessionStorage
         const sideBarExpanded = sessionStorage.getItem('sideBarSiteExpanded');

         // Method 2: Check for sidebar element class
         const sidebarElement = document.querySelector('.care-sidebar');
         const isSidebarCollapsed = sidebarElement?.classList.contains('collapsed');

         // Method 3: Check Redux state if available
         // const reduxSidebarState = useSelector((state) => state.UIReducer.sideBarExpanded);

         // Determine collapsed state (prioritize DOM check, then sessionStorage)
         let isCollapsed = false;

         if (sidebarElement) {
            isCollapsed = isSidebarCollapsed;
         } else if (sideBarExpanded !== null) {
            isCollapsed = sideBarExpanded === 'false';
         }

         setSidebarCollapsed(isCollapsed);

         // Update body class for CSS targeting
         document.body.classList.toggle('sidebar-collapsed', isCollapsed);
         document.body.classList.toggle('sidebar-expanded', !isCollapsed);
      };

      // Initial check
      checkSidebarState();

      // Listen for sidebar toggle events
      const handleSidebarToggle = () => {
         // Small delay to ensure DOM is updated
         setTimeout(checkSidebarState, 50);
      };

      // Method 1: Listen for custom sidebar toggle event
      window.addEventListener('sidebarToggle', handleSidebarToggle);

      // Method 2: Listen for sessionStorage changes
      window.addEventListener('storage', (e) => {
         if (e.key === 'sideBarSiteExpanded') {
            handleSidebarToggle();
         }
      });

      // Method 3: MutationObserver to watch for sidebar class changes
      const sidebarElement = document.querySelector('.care-sidebar');
      let observer = null;

      if (sidebarElement) {
         observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
               if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  checkSidebarState();
               }
            });
         });

         observer.observe(sidebarElement, {
            attributes: true,
            attributeFilter: ['class'],
         });
      }

      // Method 4: Poll for changes (fallback)
      const pollInterval = setInterval(checkSidebarState, 500);

      // Cleanup
      return () => {
         window.removeEventListener('sidebarToggle', handleSidebarToggle);
         window.removeEventListener('storage', handleSidebarToggle);
         if (observer) observer.disconnect();
         clearInterval(pollInterval);
      };
   }, []);

   /**
    * Handle clicks outside dropdowns
    */
   useEffect(() => {
      const handleClickOutside = (event) => {
         if (locationDropdownOpen && !event.target.closest('.caredaily-location-selector')) {
            setLocationDropdownOpen(false);
         }
         if (dropdownOpen && !event.target.closest('.caredaily-user-dropdown')) {
            profileToggle();
         }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
   }, [locationDropdownOpen, dropdownOpen]);
   useEffect(() => {
      if (!branches || branches.length === 0) return;

      const storedBranchId = sessionStorage.getItem('branchId');

      if (storedBranchId) {
         const match = branches.find((b) => String(b._id) === String(storedBranchId));
         if (match) {
            setSelectedLocation({
               id: match._id,
               name: match.name,
               badge: match.badge,
            });
            return;
         }
      }

      // fallback: default to first branch if nothing in session or no match
      const first = branches[0];
      setSelectedLocation({
         id: first._id,
         name: first.name,
         badge: first.badge,
      });
   }, [branches]);
   // Add these helper functions
   const toggleLocationDropdown = () => {
      setLocationDropdownOpen(!locationDropdownOpen);
   };

   const selectLocation = (location) => {
      setSelectedLocation(location);
      setLocationDropdownOpen(false);

      sessionStorage.setItem('branch', location._id);
   };

   // Add this useEffect to handle outside clicks
   useEffect(() => {
      const handleClickOutside = (event) => {
         if (locationDropdownOpen && !event.target.closest('.caredaily-location-selector')) {
            setLocationDropdownOpen(false);
         }
         if (dropdownOpen && !event.target.closest('.caredaily-user-dropdown')) {
            profileToggle();
         }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
   }, [locationDropdownOpen, dropdownOpen]);

   const toggleDropdown = () => {
      setIsOpen(!isOpen);
   };

   const handleMouseEnter = () => {
      setIsOpen(true);
   };

   const handleMouseLeave = () => {
      setIsOpen(false);
   };
   const policyOver = () => {
      setIsOpenPolicy(true);
   };
   const policyNotOver = () => {
      setIsOpenPolicy(false);
   };
const DISMISS_SUBS_KEY = 'dismiss_subs_timestamp';
const DISMISS_COMP_KEY = 'dismiss_comp_details_timestamp';
const DISMISS_DURATION = 14 * 24 * 60 * 60 * 1000; // 14 days in milliseconds
const shouldShowNotification = (key) => {
   const dismissedAt = localStorage.getItem(key);
   if (!dismissedAt) return true;
   
   const timePassed = Date.now() - parseInt(dismissedAt, 10);
   return timePassed >= DISMISS_DURATION;
};
   useEffect(() => {
      new WOW().init();
      const connectionOptions = {
         reconnection: true,
         reconnectionDelay: 1000,
         reconnectionDelayMax: 5000,
         'force new connection': true,
         reconnectionAttempts: 'Infinity',
         timeout: 10000,
         forceNew: true,
         transports: ['websocket'],
      };
      const connectionOptions_live = {
         reconnection: true,
         reconnectionDelay: 1000,
         reconnectionDelayMax: 5000,
         'force new connection': true,
         reconnectionAttempts: 'Infinity',
         timeout: 10000,
         forceNew: true,
      };
      let socket = '';
      if (String(NodeURL) === 'https://www.caredaily.co.uk') {
         socket = io(NodeURL, connectionOptions_live);
      } else {
         socket = io(NodeURL, connectionOptions);
      }
      socket.emit('connection', {});
      socket.on('connection', () => {
         console.log(`Connected with back end`);
      });
      socket.on('login_success', (data) => {
         if (data && data.userId) {
            if (String(data.userId) === String(sessionStorage.getItem('login_user_id')) || String(data.userId) === String(sessionStorage.getItem('userId'))) {
               getCompanyDetails();
               dispatch(get_comp_details_keys());
               dispatch(viewProfile());
            }
         }
      });

      if (props.location.search && props.location.search !== '') {
         let userDetails = props.location.search
            .substr(1)
            .split('&')
            .reduce(function (accumulator, currentValue) {
               var pair = currentValue.split('=').map(function (value) {
                  return decodeURIComponent(value);
               });
               accumulator[pair[0]] = pair[1];
               return accumulator;
            }, {});
         if (userDetails !== '') {
            dispatch(adminUserLogin(userDetails));
         }
      } else {
         let data = sessionStorage.getItem('usersessiontoken');
         if (data) {
            data = JSON.parse(data);
            let now = new Date();
            let expiration = new Date(data.timestamp);
            expiration.setMinutes(expiration.getMinutes() + 240);
            if (now.getTime() > expiration.getTime()) {
               dispatch(logOut(props.history));
            }
         }
         if (sessionStorage.getItem('isAuthenticated') === 'true') {
            dispatch(userLogin());
         }
      }
      dispatch(categoryList());
      dispatch(getSettingsData());
      if (sessionStorage.getItem('DISMIS_1')) dispatch(DISMIS_1());
      if (sessionStorage.getItem('DISMIS')) dispatch(DISMIS());

      let host = window.location.hostname;
      let hasSubdomain = host.split('.').length > 1 ? true : false;
      if (hasSubdomain) {
         let domainName = host.split('.')[0];
         if (domainName !== 'caredocument' || domainName !== 'cloudoc' || domainName !== 'www') {
            dispatch(getCompanyCredetials(domainName, props));
         }
      }

      return () => {
         dispatch(Clear_subs_Data());
         sessionStorage.removeItem('activeClass');
      };
   }, []);

   useEffect(() => {
      getCompanyDetails();
      dispatch(countryList());
   }, [dispatch]);

   useEffect(() => {
      let pathname = window.location.pathname;
      if (companyDetails && companyDetails.subdomain && checkValue(companyDetails.subdomain)) {
         if (pathname === '/company/policy/documents' || pathname === '/company/policy/document/view') {
            let path = pathname.split('/').splice(2).join('/');
            props.history.push(`/${path}`);
         } else if (companyDetails && Object.keys(companyDetails).length > 0 && String(isAuthenticated) === 'false') {
            if (window.location && window.location.hash) {
               props.history.push(`/login/${window.location.hash}`);
            } else {
               props.history.push('/login');
            }
         }
      } else {
         if (companyDetails && Object.keys(companyDetails).length > 0 && String(isAuthenticated) === 'false') {
            props.history.push('/login');
         }
      }
   }, [companyDetails]);

   let getCompanyDetails = () => {
         let getUserId = sessionStorage.getItem('userId');
         if (getUserId) {
            dispatch(getCartCount(getUserId));
            dispatch(get_comp_details_keys());
            dispatch(getCount(getUserId));
            dispatch(viewProfile());
            dispatch(listSubscription());
            dispatch(getUserDetails(getUserId));
         } else {
            let get_offline_cart = localStorage.getItem('offline_cart_subscription_details');
            if (
               get_offline_cart &&
               String(get_offline_cart) !== String(null) &&
               String(get_offline_cart) !== String(undefined) &&
               String(get_offline_cart).length > 0
            ) {
               let parsed_cart = JSON.parse(get_offline_cart);
               dispatch(IMPORT_FROM_LOCAL(parsed_cart));
            }
         }
      },
      subdoaminToggle = () => setState({ ...state, showInfo: !state.showInfo }),
      myProfilefun = (type) => {
         props.history.push('/settings');
         sessionStorage.setItem('profileType', type);
         dispatch(LogOutModalView(props));
         dispatch(setDropdownOpen(false));
      },
      company_settings = () => {
         props.history.push('/settings');
         dispatch(setDropdownOpen(false));
      },
      subscriptionList = () => {
         props.history.push('/subscriptions');
         dispatch(setDropdownOpen(false));
      },
      restore_modal_view = () => dispatch(restoreModalView()),
      onRestoreAllDocuments = () => dispatch(restoreDocumentToCompany(restoreOption, props)),
      logout_user = (e) => {
         e.preventDefault();
         dispatch(logOut(props.history));
      },
      redirect_to = (e) => {
         e.preventDefault();
         if (userSubscribedPlan && userSubscribedPlan.length > 0) {
            props.history.push({ pathname: '/subscriptions', state: { active_tab: '1' } });
         } else {
            props.history.push({ pathname: '/pricing' });
         }
      },
      dismiss = (e) => {
   e.preventDefault();
   // Save timestamp to localStorage
   localStorage.setItem(DISMISS_COMP_KEY, Date.now().toString());
   // Also dispatch to Redux for immediate UI update
   dispatch(DISMIS());
},
dismiss_subsfun = (e) => {
   e.preventDefault();
   // Save timestamp to localStorage
   localStorage.setItem(DISMISS_SUBS_KEY, Date.now().toString());
   // Also dispatch to Redux for immediate UI update
   dispatch(DISMIS_1());
},
      // dismiss = (e) => {
      //    e.preventDefault();
      //    dispatch(DISMIS());
      //    sessionStorage.setItem('DISMIS', true);
      // },
      // dismiss_subsfun = (e) => {
      //    e.preventDefault();
      //    dispatch(DISMIS_1());
      //    sessionStorage.setItem('DISMIS_1', true);
      // },
      dismiss_msgfun = (e) => {
         e.preventDefault();
         dispatch(dismiss_msg_pop());
      },
      handleChange = (e, key) => {
         if (String(key) === 'remember') {
            formData[key] = e.target.checked;
         } else if (String(key) === 'email') {
            formData[key] = e.target.value ? String(e.target.value).toLowerCase() : '';
         } else {
            formData[key] = e.target.value ? e.target.value : '';
         }
         dispatch(addLoginData(formData));
      },
      mainToggle = () => {
         // dispatch(OtpModal())
         // setOtpModal(false)
         setShow(false);
         // dispatch(authModal('home'));
         props.history.push('/login');
      },
      loginToggle = () => {
         dispatch(signInModal());
         dispatch(clearFormData());
      },
      forgotToggle = () => dispatch(forgotModal()),
      toggleTab = (tab) => activeTab !== tab && dispatch(setActiveTab(tab)),
      signupSubmitForm = async () => {
         if (
            formData &&
            formData.firstname &&
            formData.lastname &&
            formData.email &&
            formData.password &&
            formData.companyName &&
            formData.confirmPassword &&
            formData.personal_phone &&
            formData.subdomain
         ) {
            if (!validateEmail(formData.email)) {
               dispatch(getErrorMsg('Valid Email is required'));
            } else if (String(formData.password) !== String(formData.confirmPassword)) {
               dispatch(getErrorMsg('Password and Confirm password should be same'));
            } else {
               let response = fetchData({
                  url: '/user/validate',
                  method: 'POST',
                  data: formData,
               });
               response.then(async (res) => {
                  if (res.status === 1) {
                     const token = await reRef.current.executeAsync();
                     reRef.current.reset();
                     let response = fetchData({
                        url: '/recaptcha/api/siteverify',
                        method: 'POST',
                        data: { response: token },
                     });
                     response.then((res) => {
                        if (res.success) {
                           let response = fetchData({
                              url: '/email/otp/verification',
                              method: 'POST',
                              data: { email: formData.email, name: formData.firstname + formData.lastname },
                           });
                           response.then((res) => {
                              if (res.status === 1) {
                                 dispatch(popupoff());
                                 dispatch(OtpModal(true));
                                 dispatch(popup('OTP has been sent to your registered mail successfully.'));
                                 setotp(res.data);
                                 setShowButton(true);
                              } else {
                                 dispatch(getErrorMsg('Something Went Wrong'));
                              }
                           });
                        } else {
                           dispatch(getErrorMsg(res.response));
                        }
                     });
                  } else {
                     dispatch(getErrorMsg(res.response));
                  }
               });
            }
         } else {
            dispatch(getErrorMsg('All fields are required'));
         }
      },
      loginSubmitForm = () => {
         if (
            formData &&
            formData.email &&
            String(formData.email).length > 0 &&
            String(formData.email) !== String(undefined) &&
            String(formData.email) !== String(null)
         ) {
            if (
               formData &&
               formData.password &&
               String(formData.password).length > 0 &&
               String(formData.password) !== String(undefined) &&
               String(formData.password) !== String(null)
            ) {
               dispatch(userLogin(formData, props.history, props, path));
            } else {
               dispatch(getErrorMsg('Password is required'));
            }
         } else {
            dispatch(getErrorMsg('Email is required'));
         }
      },
      handleSubmit = (e) => {
         if (formData.email && String(formData.email).length > 0) {
            if (validateEmail(formData.email)) {
               dispatch(forgotPassword(formData.email, props.history, props));
            } else {
               dispatch(getErrorMsg('Invalid email'));
            }
         } else {
            dispatch(getErrorMsg('Email is required'));
         }
      },
      setActiveClass = (data) => sessionStorage.setItem('activeClass', data),
      getCodeBoxElement = (index) => document.getElementById('otp' + index),
      jumpto = (event, index) => {
         const eventCode = event.which || event.keyCode;
         if (getCodeBoxElement(index).value.length === 1) {
            if (index !== 4) {
               getCodeBoxElement(index + 1).focus();
            } else {
               // getCodeBoxElement(index).blur();
            }
         }
         if (eventCode === 8 && index !== 1) {
            getCodeBoxElement(index - 1).focus();
         }
      },
      //   onFocusEvent = (index) => {
      //     for (let item = 1; item < index; item++) {
      //       const currentElement = getCodeBoxElement(item);
      //       if (!currentElement.value) {
      //           currentElement.focus();
      //           break;
      //       }
      //     }
      //   }

      submitOtp = () => {
         if (
            formData &&
            formData.otp1 &&
            formData.otp1 !== '' &&
            formData.otp2 &&
            formData.otp2 !== '' &&
            formData.otp3 &&
            formData.otp3 !== '' &&
            formData.otp4 &&
            formData.otp4 !== ''
         ) {
            dispatch(otpSubmit(formData, forgotUser));
         } else {
            dispatch(getErrorMsg('Enter correct otp'));
         }
      },
      resendotp = () => {
         let response = fetchData({
            url: '/email/otp/verification',
            method: 'POST',
            data: { email: formData.email, name: formData.firstname + formData.lastname },
         });
         response.then((res) => {
            if (res.status === 1) {
               dispatch(popup('OTP has been successfully resent to your registered email'));
               setShowButton(true);
               setotp(res.data);
            }
         });
      },
      submitemailOtp = () => {
         if (
            formData &&
            formData.otp1 &&
            formData.otp1 !== '' &&
            formData.otp2 &&
            formData.otp2 !== '' &&
            formData.otp3 &&
            formData.otp3 !== '' &&
            formData.otp4 &&
            formData.otp4 !== ''
         ) {
            let response = fetchData({
               url: '/otp/time/verification',
               method: 'POST',
               data: { data: otpnum, votp: formData.otp1 + formData.otp2 + formData.otp3 + formData.otp4 },
            });
            response.then((res) => {
               if (res.status === 1) {
                  dispatch(saveSignUp(formData, props));
               } else {
                  dispatch(getErrorMsg(res.response));
               }
            });
         } else {
            dispatch(getErrorMsg('Enter correct otp'));
         }
      },
      // gotoDocuments = () => {
      //     let token = sessionStorage.getItem('token'),
      //         login_user_id = sessionStorage.getItem('login_user_id'),
      //         user_permission = sessionStorage.getItem('user_permission'),
      //         userId = sessionStorage.getItem('userId'),
      //         sideBarSiteExpanded = sessionStorage.getItem('sideBarSiteExpanded'),
      //         companyUserId = sessionStorage.getItem('companyUserId'),
      //         usersessiontoken = sessionStorage.getItem('usersessiontoken'),
      //         userRole = sessionStorage.getItem('userRole'),
      //         isAuthenticated = sessionStorage.getItem('isAuthenticated'),
      //         userName = sessionStorage.getItem('userName'),
      //         subDomain = myProfile && myProfile.companyDetails && myProfile.companyDetails.subdomain ? myProfile.companyDetails.subdomain : ''
      //     if (subDomain && subDomain !== '' && subDomain !== undefined) {
      //         if (RootdomainURL.includes('localhost')) {
      //             window.location.href = `http://${subDomain}.${RootdomainURL}/company/dashboard`;
      //         } else {
      //             window.location.href = `https://${subDomain}.${RootdomainURL}/company/dashboard`;
      //         }
      //     } else {
      //         props.history.push('/dashboard');
      //     }

      //     sessionStorage.setItem('token', token);
      //     sessionStorage.setItem('login_user_id', login_user_id);
      //     sessionStorage.setItem('user_permission', user_permission);
      //     sessionStorage.setItem('userId', userId);
      //     sessionStorage.setItem('sideBarSiteExpanded', sideBarSiteExpanded);
      //     sessionStorage.setItem('companyUserId', companyUserId);
      //     sessionStorage.setItem('usersessiontoken', usersessiontoken);
      //     sessionStorage.setItem('userRole', userRole);
      //     sessionStorage.setItem('isAuthenticated', isAuthenticated);
      //     sessionStorage.setItem('userName', userName);
      //     sessionStorage.setItem('subDomain', subDomain);
      // },

      // otpToggle = () => dispatch(otpModal()),

      // newPwdToggle = () => dispatch(newPwdModal()),

      // otpChange = (e) => {
      //     let newvalue = e.target.value.replace(/[^0-9]/g, '');
      //     if (newvalue && newvalue.length > 0) {
      //         setState({ ...state, otpValue: newvalue })
      //     }
      // },

      // toggle = () => dispatch(setDropdownOpen()),

      // tooltipToggle = () => setState({ ...state, tooltipOpen: !state.tooltipOpen }),

      submitNewPassword = () => dispatch(createNewPassword(formData, forgotUser)),
      openPopup = () => openPopupWidget({ url, prefill, pageSettings, utm }),
      notification = (key) => {
         let getUserId = sessionStorage.getItem('userId');
         dispatch(getNotifications(getUserId, 10));
         key === 'home' ? dispatch(changeModal('home')) : dispatch(changeModal('document'));
      },
      profileToggle = () => dispatch(setDropdownOpen(!dropdownOpen)),
      gotoPublicDocument = () => {
         props.history.push('/publishedpolicies');
         dispatch(setDropdownOpen(false));
      };

   // if (licenseStatus && checkValue(licenseStatus) && licenseStatus === 'expired') {
   //     if (window.location.pathname === '/company/subscriptions') {
   //         dispatch(subExpiryNotifyToggle(false))
   //     } else {
   //         dispatch(subExpiryNotifyToggle(true))
   //     }
   // }

   let activeClass = sessionStorage.getItem('activeClass') ? sessionStorage.getItem('activeClass') : null;
   let user_permission = sessionStorage.getItem('user_permission') ? JSON.parse(sessionStorage.getItem('user_permission')) : [];
   if (showError === true) {
      setTimeout(() => {
         dispatch(closeErrorMsg());
      }, 2000);
   }
   let displayName =
      myProfile.firstname && myProfile.lastname
         ? myProfile.firstname.charAt(0) + myProfile.lastname.charAt(0)
         : myProfile.username
         ? myProfile.username.charAt(0) + myProfile.username.charAt(myProfile.username.length - 1)
         : myProfile.companyName
         ? myProfile.companyName.charAt(0) + myProfile.companyName.charAt(myProfile.companyName.length - 1)
         : null;
   let longName =
      myProfile.firstname && myProfile.lastname
         ? myProfile.firstname + ' ' + myProfile.lastname
         : myProfile.username
         ? myProfile.username
         : myProfile.companyName
         ? myProfile.companyName
         : null;
   let isAuthenticated = sessionStorage.getItem('isAuthenticated') ? sessionStorage.getItem('isAuthenticated') : authCheck;

   const excludedPaths = [
      '/documents',
      '/dashboard',
      '/users',
      '/subscriptions',
      '/users/add',
      '/users/edit',
      '/users/activity',
      '/saved-documents',
      '/create-new-documents',
      '/users/deleted-list',
      '/subscription/pay',
      '/documents/compare',
      '/documents/editor',
      '/index',
      '/documents/recent-updates',
      '/documents/need-review',
      '/documents/uptodate',
      '/settings',
      '/document/management/renewal',
      '/invoice',
      '/notifications',
      '/history',
      '/groups',
      '/group/add',
      '/group/edit',
      '/group/view',
      '/policies',
      '/policies/edit',
      '/policies/create',
      '/policies/multi/create',
      '/users/view',
      '/policy-documents',
      '/employees',
      '/employee/add',
      '/employee/edit',
      '/employee/view',
      '/deleted/employees',
      '/forgotpassword',
      '/employee/login',
      '/employee/register',
      '/verifyotp',
      '/resetpassword',
      '/myfiles',
      '/myfiles/editor',
      '/myfiles/details',
      '/policy/documents',
      '/policy/document/view',
      '/publishedpolicies',
      '/deleted-documents',
      '/myDocuments',
      '/myDocuments/editor',
      '/view/Document',
      '/myDocuments/details',
      '/course',
      '/formslist',
      '/webform',
      '/formbuilder',
   ];

   const modalpolicyChange = (value) => {
      props.history.push({ pathname: '/policies-procedures', state: { category: value } });
      setIsModalOpen(false);
   };
   const movetoContact = () => {
      props.history.push('/contact-us');
      setIsModalOpen(false);
   };
   const modalpolicyCountrychange = (value) => {
      props.history.push({ pathname: '/policies-procedures', state: { country: value } });
      setIsModalOpen(false);
   };
   const policyPromo = () => {
      let promoLink = settingsData?.promolink;
      if (promoLink && promoLink.includes('/policies-procedures')) {
         props.history.push({ pathname: '/policies-procedures', state: { country: 'england' } });
      } else {
         window.location.href = promoLink; // Navigate to the link
      }
   };
   if (
      props.location &&
      !excludedPaths.includes(props.location.pathname) &&
      !props.location.pathname.startsWith('/reference/') &&
      !props.location.pathname.startsWith('/document/sign') &&
      !props.location.pathname.startsWith('/webform/fill') &&
      !props.location.pathname.startsWith('/webform/completed') &&
      !props.location.pathname.startsWith('/view/Document/') &&
      !routeAccess?.hasHeader
   ) {
      let pathname = '/';
      const exceptThisSymbols = ['e', 'E', '+', '-', '.'];
      const toggleModals = (target) => {
         setIsModalCareOpen(target === 'care');
         setIsModalOpen(target === 'policies');
         setIsModalResourceOpen(target === 'resource');
      };

      return (
         <>
            <div className="header-with-promo">
               {/* Promo Section -- Start */}
               {settingsData?.offerStatus === 1 && settingsData?.promonotice === 1 && showPromo ? (
           
                  <>
                  {/* <div 
  className="promotional-banner-wrapper" 
  style={{ background: settingsData?.promobackground || '#f5f5f5' }}
>
  <div className="promotional-left-section">
    <div className="promotional-icon-box">
      <img 
        src={settingsData?.promoicon || '/assets/images/promo.svg'} 
        alt="Promo" 
      />
    </div>
    <div className="promotional-text-content">
      <h3 
        className="promotional-title" 
        style={{ color: settingsData?.promofont }}
      >
        {settingsData?.promotitle}
      </h3>
      <p 
        className="promotional-subtitle" 
        style={{ color: settingsData?.promofont }}
      >
        {settingsData?.promodescription}
      </p>
    </div>
  </div>

  <div className="promotional-right-section">
    <div className="countdown-boxes">
      <Timer 
        expiryTimestamp={settingsData?.offerExpiry} 
        color={settingsData?.promofont} 
      />
    </div>
    <button 
      className="promotional-cta-button"
      onClick={policyPromo}
      style={{ 
        background: settingsData?.promoButton, 
        color: settingsData?.promofont 
      }}
    >
      {settingsData?.promobutton || "Let's Get Festive"}
    </button>
  </div>

  <button 
    className="promotional-close-button" 
    onClick={() => setShowpromo(false)}
    style={{ color: settingsData?.promofont }}
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>
</div> */}
{/* Updated Promotional Banner JSX */}

<div 
  className="promotional-banner-wrapper" 
  style={{ background: settingsData?.promobackground || '#7c3aed' }}
>
  {/* LEFT: Icon + Text */}
  <div className="promotional-left-section">
    <div className="promotional-icon-box">
      <img 
        src={settingsData?.promoicon || '/assets/images/promo.svg'} 
        alt="Promo" 
      />
    </div>
    <div className="promotional-text-content">
      <h3 
        className="promotional-title" 
        style={{ color: settingsData?.promofont || '#ffffff' }}
      >
        {settingsData?.promotitle}
        {/* <span className="promotional-badge">Limited Offer</span> */}
      </h3>
      <p 
        className="promotional-subtitle" 
        style={{ color: settingsData?.promofont || '#ffffff' }}
      >
        {settingsData?.promodescription}
      </p>
    </div>
  </div>

  {/* RIGHT: Timer + CTA Button */}
  <div className="promotional-right-section">
    <div className="countdown-boxes">
      <Timer 
        expiryTimestamp={settingsData?.offerExpiry} 
        color={settingsData?.promofont || '#ffffff'} 
      />
    </div>
    <button 
      className="promotional-cta-button"
      onClick={policyPromo}
      style={{ 
        background: settingsData?.promoButton || '#f97316', 
        color: settingsData?.promofont || '#ffffff' 
      }}
    >
      {settingsData?.promobutton || "Buy Now!"}
    </button>
  </div>

  {/* CLOSE BUTTON */}
  <button 
    className="promotional-close-button" 
    onClick={() => setShowpromo(false)}
    style={{ color: settingsData?.promofont || '#ffffff' }}
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>
</div>
                 
                  </>
               ) : null}
               <section className={String(props.location.pathname) === String('/') ? 'new-header' : 'new-header'}>
               <div className="container">
                  <div className="row">
                     <div className="col-lg-2 col-md-4 col-sm-12 col-xs-12 head-left">
                        <div className="site-logo">
                           {String(props.location.pathname) === '/policies-procedures' ||
                           String(props.location.pathname).includes('/subscription-detail') ||
                           String(props.location.pathname) === '/signin' ||
                           String(props.location.pathname) === '/signup' ||
                           String(props.location.pathname) === '/cart' ||
                           String(props.location.pathname) === '/order/history' ||
                           String(props.location.pathname) === '/checkout' ||
                           String(props.location.pathname) === '/faq' ||
                           String(props.location.pathname) === '/profile' ||
                           String(props.location.pathname) === '/pages/privacy-policy' ||
                           String(props.location.pathname) === '/contact-us' ||
                           String(props.location.pathname) === '/features' ||
                           String(props.location.pathname) === '/knowledge' ||
                           String(props.location.pathname) === '/pages/disclaimer' ||
                           String(props.location.pathname) === '/pages/user-licence-agreement' ||
                           String(props.location.pathname) === '/pages/disclaimer' ||
                           String(props.location.pathname) === '/forgotpassword' ||
                           String(props.location.pathname) === '/pages/terms-and-conditions' ||
                           String(props.location.pathname).includes('/pages/') ||
                           String(props.location.pathname).includes('/404') ||
                           String(props.location.pathname).includes('/resetpassword/') ? (
                              <Link to={pathname} onClick={() => sessionStorage.removeItem('activeClass')}>
                                 <img src={logo} alt="logo2" className="home-logo" />
                              </Link>
                           ) : (
                              <Link to={pathname} onClick={() => sessionStorage.removeItem('activeClass')}>
                                 <img src={settingsData && settingsData.admin_logo ? settingsData.admin_logo : logo} alt="logo2" className="home-logo" />
                              </Link>
                           )}
                        </div>
                     </div>
                     {props.location.pathname === '/profile' && sessionStorage.getItem('userRole') !== 'user' ? (
                        pop_show && !dismiss_msg ? (
                           <div className="top-pop">
                              <span>
                                 Thank you for purchasing your documents, your documents are now available, you can access them by clicking the Documents menu,
                                 in order to customise them, please click here to complete you business information as you would like it to appear on the
                                 documents.{' '}
                              </span>
                              <span>
                                 <button onClick={(e) => dismiss_msgfun(e)}>Dismiss</button>
                              </span>
                           </div>
                        ) : null
                     ) : null}
                     <div className="col-lg-10 col-md-8 col-sm-12 col-xs-12 head-right">
                        <div className="not-cart">
                           <ul>
                              <li className="nav-item">
                                 <Link className="nav-link" to="/cart">
                                    <div className="basket-icon">
                                       <img src={trolly} alt="cart" />
                                       <span className={1 > 0 ? 'bell' : 'bell-count'}>{offline_cart_data_count}</span>
                                    </div>
                                 </Link>
                              </li>
                           </ul>
                        </div>

                        <nav className="navbar navbar-expand-lg navbar-light bg-light new-nav-lists">
                           <button className="navbar-toggler" onClick={() => dispatch(mobileModalFunc())}>
                              <span className="navbar-toggler-icon"></span>
                           </button>
                           <div className="collapse navbar-collapse" id="navbarNavDropdown" style={{ display: !show && showMainModal ? 'none' : '' }}>
                              <ul className="navbar-nav">
                                 <div className="navbar-nav-left">
                                    {/* {String(isAuthenticated) === String('true') ? (
                                       <li className="nav-item">
                                          <Link className="nav-link" style={{ color: '#f77d24' }} to="/dashboard">
                                             My Cloudoc
                                          </Link>
                                       </li>
                                    ) : null} */}

                                    {/* Care Management Dropdown */}
                                    {String(isAuthenticated) === String('true') ? (
                                       <li className="nav-item">
                                          {props.location.pathname.includes('/care-management') ? (
                                             <NavLink
                                                className={isModalOpenCare ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('care')}
                                                onClick={() => toggleModals('care')}
                                             >
                                                Care Management{' '}
                                                {isModalOpenCare ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          ) : (
                                             <NavLink
                                                className={isModalOpenCare ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('care')}
                                                onClick={() => toggleModals('care')}
                                             >
                                                Care Management{' '}
                                                {isModalOpenCare ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          )}
                                       </li>
                                    ) : (
                                       <li className="nav-item" onClick={() => setActiveClass(6)}>
                                          {props.location.pathname.includes('/care-management') ? (
                                             <NavLink
                                                className={isModalOpenCare ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('care')}
                                                onClick={() => toggleModals('care')}
                                             >
                                                Care Management{' '}
                                                {isModalOpenCare ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          ) : (
                                             <>
                                                <NavLink
                                                   className={isModalOpenCare ? 'nav-link active-navItem' : 'nav-link'}
                                                   onMouseOver={() => toggleModals('care')}
                                                   onClick={() => toggleModals('care')}
                                                >
                                                   Care Management{' '}
                                                   {isModalOpenCare ? (
                                                      <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                   ) : (
                                                      <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                   )}
                                                </NavLink>
                                             </>
                                          )}
                                       </li>
                                    )}

                                    {/* Policies & Procedures Dropdown */}
                                    {String(isAuthenticated) === String('true') ? (
                                       <li className="nav-item">
                                          {props.location.pathname.includes('/policies-procedures') ? (
                                             <NavLink
                                                className={isModalOpen ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('policies')}
                                                onClick={() => toggleModals('policies')}
                                             >
                                                Policies & Procedures{' '}
                                                {isModalOpen ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          ) : (
                                             <NavLink
                                                className={isModalOpen ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('policies')}
                                                onClick={() => toggleModals('policies')}
                                             >
                                                Policies & Procedures{' '}
                                                {isModalOpen ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          )}
                                       </li>
                                    ) : (
                                       <li className="nav-item" onClick={() => setActiveClass(1)}>
                                          {props.location.pathname.includes('/policies-procedures') ? (
                                             <NavLink
                                                className={isModalOpen ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('policies')}
                                                onClick={() => toggleModals('policies')}
                                             >
                                                Policies & Procedures{' '}
                                                {isModalOpen ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          ) : (
                                             <>
                                                <NavLink
                                                   className={isModalOpen ? 'nav-link active-navItem' : 'nav-link'}
                                                   onMouseOver={() => toggleModals('policies')}
                                                   onClick={() => toggleModals('policies')}
                                                >
                                                   Policies & Procedures{' '}
                                                   {isModalOpen ? (
                                                      <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                   ) : (
                                                      <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                   )}
                                                </NavLink>
                                             </>
                                          )}
                                       </li>
                                    )}

                                    {/* Document Search */}
                                    {/* {
                                 <li className="nav-item" onClick={() => setActiveClass(3)}>
                                    <Link className={activeClass === '3' ? 'nav-link active-navItem' : 'nav-link'} to="/documentlibrary">
                                       Document Search
                                    </Link>
                                 </li>
                              } */}

                                    {/* System Features */}
                                    {/* {String(isAuthenticated) === String('true') ? <>
                                 <NavLink
                                    className={isModalOpenFea ? 'nav-link active-navItem' : 'nav-link'}
                                    onMouseOver={() => setIsModalFeaOpen(true)}
                                    onClick={() => setIsModalFeaOpen(true)}
                                 >
                                    System Features {isModalOpenFea ? <i className="fa-solid fa-angle-up" style={{ color: "#54bdb8" }}></i> : <i className="fa-solid fa-angle-down" style={{ color: "#54bdb8" }}></i>}
                                 </NavLink>
                              </> : (
                                 <>
                                    <NavLink
                                       className={isModalOpenFea ? 'nav-link active-navItem' : 'nav-link'}
                                       onMouseOver={() => setIsModalFeaOpen(true)}
                                       onClick={() => setIsModalFeaOpen(true)}
                                    >
                                       System Features {isModalOpenFea ? <i className="fa-solid fa-angle-up" style={{ color: "#54bdb8" }}></i> : <i className="fa-solid fa-angle-down" style={{ color: "#54bdb8" }}></i>}
                                    </NavLink>
                                 </>
                              )} */}

                                    {/* Resources Dropdown */}
                                    {String(isAuthenticated) === String('true') ? (
                                       <li className="nav-item">
                                          {props.location.pathname.includes('/Resources') ? (
                                             <NavLink
                                                className={isModalOpenResource ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('resource')}
                                                onClick={() => toggleModals('resource')}
                                             >
                                                Resources{' '}
                                                {isModalOpenResource ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          ) : (
                                             <NavLink
                                                className={isModalOpenResource ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('resource')}
                                                onClick={() => toggleModals('resource')}
                                             >
                                                Resources{' '}
                                                {isModalOpenResource ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          )}
                                       </li>
                                    ) : (
                                       <li className="nav-item" onClick={() => setActiveClass(6)}>
                                          {props.location.pathname.includes('/Resources') ? (
                                             <NavLink
                                                className={isModalOpenResource ? 'nav-link active-navItem' : 'nav-link'}
                                                onMouseOver={() => toggleModals('resource')}
                                                onClick={() => toggleModals('resource')}
                                             >
                                                Resources{' '}
                                                {isModalOpenResource ? (
                                                   <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                ) : (
                                                   <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                )}
                                             </NavLink>
                                          ) : (
                                             <>
                                                <NavLink
                                                   className={isModalOpenResource ? 'nav-link active-navItem' : 'nav-link'}
                                                   onMouseOver={() => toggleModals('resource')}
                                                   onClick={() => toggleModals('resource')}
                                                >
                                                   Resources{' '}
                                                   {isModalOpenResource ? (
                                                      <i className="fa-solid fa-angle-up" style={{ color: '#54bdb8' }}></i>
                                                   ) : (
                                                      <i className="fa-solid fa-angle-down" style={{ color: '#54bdb8' }}></i>
                                                   )}
                                                </NavLink>
                                             </>
                                          )}
                                       </li>
                                    )}

                                    {/* <Dropdown isOpen={isOpen} toggle={() => { }} onMouseOver={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                 <li className="nav-item">
                                    <DropdownToggle caret>Resources</DropdownToggle>
                                 </li>
                                 <DropdownMenu>
                                    <Link to="/knowledge" className="dropdown-item">
                                       Knowledgebase
                                    </Link>
                                    <Link to="/faq" className="dropdown-item">
                                       FAQs
                                    </Link>
                                    <Link to="/systemdocumentation" className="dropdown-item">
                                       System Documentation
                                    </Link>
                                 </DropdownMenu>
                              </Dropdown> */}

                                    {/* Pricing */}
                                    {/* {String(isAuthenticated) === String('true') ? (
                                       <li className="nav-item" onClick={() => setActiveClass(4)}>
                                          <Link className={activeClass === '4' ? 'nav-link active-navItem' : 'nav-link'} to="/pricing">
                                             Pricing{' '}
                                          </Link>
                                       </li>
                                    ) : (
                                       <li className="nav-item" onClick={() => setActiveClass(4)}>
                                          <Link className={activeClass === '4' ? 'nav-link active-navItem' : 'nav-link'} to="/pricing">
                                             Pricing{' '}
                                          </Link>
                                       </li>
                                    )} */}

                                    {/* Contact Us */}
                                    {/* {String(isAuthenticated) === String('true') ? null : (
                                 <li className="nav-item" onClick={() => setActiveClass(4)}>
                                    <Link className={activeClass === '4' ? 'nav-link active-navItem' : 'nav-link'} to="/contact-us">
                                       Contact Us{' '}
                                    </Link>
                                 </li>
                              )} */}
                                 </div>
                                 <div className="navbar-nav-right">
                                    {/* My Account */}
                                    {String(isAuthenticated) === String(true) ? (
                                       <li className="nav-item dropdown site-dropdown">
                                          <a
                                             className="nav-link dropdown-toggle my-acc-lnk"
                                             href="#"
                                             id="navbarDropdownMenuLink"
                                             data-toggle="dropdown"
                                             aria-haspopup="true"
                                             aria-expanded="false"
                                          >
                                             My Account
                                          </a>
                                          <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                             <a className="dropdown-item" onClick={() => myProfilefun('myprofile')} href="#">
                                                My account
                                             </a>
                                             <a className="dropdown-item" onClick={() => props.history.push('/dashboard')} href="#">
                                                Dashboard
                                             </a>
                                             <a className="dropdown-item" onClick={() => props.history.push('/order/history')} href="#">
                                                Order history
                                             </a>
                                             <a className="dropdown-item log-out" href="#" onClick={(e) => logout_user(e)}>
                                                Logout
                                             </a>
                                          </div>
                                       </li>
                                    ) : null}
  {String(isAuthenticated) !== String(true) && (<a href="tel:03308080050" class="nav-phone">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                    0330 808 0050
                </a>
  )}
                                    {/* Sign In */}
                                    {String(isAuthenticated) !== String(true) && (
                                       <li className="nav-item demo-but">
                                          {/* <Link className="nav-link" onClick={mainToggle}> */}
                                          <Link className="nav-link" to="/login">
                                             Login
                                          </Link>
                                       </li>
                                    )}

                                    {/* Get a Demo */}
                                    {/* <li className="nav-item get-a-demo" onClick={() => setActiveClass(10)}>
                                       <span
                                          className={activeClass === '10' ? 'nav-link active-navItem' : 'nav-link'}
                                          onClick={()=> props.history.push('/startnow')}
                                          id={String(isAuthenticated) === String(true) ? 'buy-pol-authenticated' : 'buy-pol'}
                                       >
                                          Start Now
                                       </span>
                                    </li> */}
                                    <li className="nav-item get-a-demo" onClick={() => setActiveClass(10)}>
                                       <span
                                          className={activeClass === '10' ? 'nav-link active-navItem' : 'nav-link'}
                                          onClick={(e)=> openCalendly(e)}
                                          id={String(isAuthenticated) === String(true) ? 'buy-pol-authenticated' : 'buy-pol'}
                                       >
                                          Book a Demo
                                       </span>
                                    </li>


                                    {/* Cart */}
                                    {String(isAuthenticated) === String(true) ? (
                                       <li className="nav-item nav-basket">
                                          <Link className="nav-link" to="/cart">
                                             <div className="basket-icon">
                                                <img src={trolly} alt="cart" />
                                                <span className={cartCount > 0 ? 'bell' : ''}>{cartCount > 0 ? cartCount : ''}</span>
                                             </div>
                                          </Link>
                                       </li>
                                    ) : (
                                       <li className="nav-item  basket-svg" onClick={() => setActiveClass(5)}>
                                          <Link className={activeClass === '5' ? 'nav-link active-navItem' : 'nav-link'} to="/cart">
                                             <div className={activeClass === '5' ? 'basket-icon active-basket' : 'basket-icon'}>
                                                <img src={trolly} alt="cart" />
                                                <span className={offline_cart_data_count > 0 ? 'bell' : ''}>
                                                   {offline_cart_data_count > 0 ? offline_cart_data_count : ''}
                                                </span>
                                             </div>
                                          </Link>
                                       </li>
                                    )}

                                    {/* Notifications */}
                                    {String(isAuthenticated) === String(true) ? (
                                       <li className="nav-item bell-icon">
                                          <IconButton aria-label="notification" onClick={() => notification('home')}>
                                             {unReadCount > 0 ? <Badge badgeContent={unReadCount} className="home-badge"></Badge> : null}
                                             <NotificationsIcon style={{ color: grey[900] }} />
                                          </IconButton>
                                       </li>
                                    ) : null}
                                 </div>
                              </ul>
                           </div>
                        </nav>
                     </div>
                  </div>
</div>
                  {/* Care Management Dropdown Modal */}
                  {isModalOpenCare && (
                     <CareManagementDropdown
                        isOpen={isModalOpenCare}
                        onClose={() => setIsModalCareOpen(false)}
                        history={history}
                        movetoContact={movetoContact}
                     />
                  )}

                  {/* Policies & Procedures Dropdown Modal */}
                  {isModalOpen && (
                     <CloudDocDropdown
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        sub_categoryList={sub_categoryList}
                        history={history}
                        modalpolicyChange={modalpolicyChange}
                        modalpolicyCountrychange={modalpolicyCountrychange}
                        countriesList={countriesList}
                        movetoContact={movetoContact}
                     />
                  )}

                  {/* Resouces Dropdown Modal */}
                  {isModalOpenResource && (
                     <ResourceDropdown
                        isOpen={isModalOpenResource}
                        onClose={() => setIsModalResourceOpen(false)}
                        history={history}
                        movetoContact={movetoContact}
                     />
                  )}

                  {/* System Features Modal */}
                  {isModalOpenFea && <FeaturesGrid isOpen={isModalOpenFea} onClose={() => setIsModalFeaOpen(false)} history={history} />}

                  {showNotification ? <NotificationModal history={props.history} /> : null}
                  {showOneNotification ? <OneNotificationModal /> : null}
                  {showRestoreModal ? <RestoreModal history={props.history} restoreFunction={onRestoreAllDocuments} /> : null}
                  {pop_show_hide ? <BottomModal history={props.history} /> : null}
                  {showMainModal ? <LoginSignupModal history={props.history} /> : null}
                  {subdomainRemindModal && <SubdomainRemind history={props.history} />}
                  {/* {mobileModal ? <MobileModal history={props.history} /> : null} */}
                  <MobileDrawer 
                     isOpen={mobileModal} 
                     onClose={() => dispatch(mobileModalFunc())} 
                     history={props.history}
                  />
               </section>
            </div>
         </>
      );
   } else if (
      props.location.pathname === '/documents' ||
      props.location.pathname === '/dashboard' ||
      props.location.pathname === '/subscriptions' ||
      props.location.pathname === '/users' ||
      props.location.pathname === '/course' ||
      props.location.pathname === '/formslist' ||
      props.location.pathname === '/formbuilder' ||
      props.location.pathname === '/webform' ||
      props.location.pathname === '/users/add' ||
      props.location.pathname === '/users/edit' ||
      props.location.pathname === '/users/activity' ||
      props.location.pathname === '/saved-documents' ||
      props.location.pathname === '/create-new-documents' ||
      props.location.pathname === '/users/deleted-list' ||
      props.location.pathname === '/subscription/pay' ||
      props.location.pathname === '/documents/compare' ||
      props.location.pathname === '/index' ||
      props.location.pathname === '/documents/recent-updates' ||
      props.location.pathname === '/documents/need-review' ||
      props.location.pathname === '/documents/uptodate' ||
      props.location.pathname === '/settings' ||
      props.location.pathname === '/document/management/renewal' ||
      props.location.pathname === '/invoice' ||
      props.location.pathname === '/notifications' ||
      props.location.pathname === '/history' ||
      props.location.pathname === '/groups' ||
      props.location.pathname === '/group/add' ||
      props.location.pathname === '/group/edit' ||
      props.location.pathname === '/group/view' ||
      props.location.pathname === '/policies' ||
      props.location.pathname === '/policies/edit' ||
      props.location.pathname === '/policies/create' ||
      props.location.pathname === '/users/view' ||
      props.location.pathname === '/policy-documents' ||
      props.location.pathname === '/employees' ||
      props.location.pathname === '/employee/add' ||
      props.location.pathname === '/employee/edit' ||
      props.location.pathname === '/employee/view' ||
      props.location.pathname === '/deleted/employees' ||
      props.location.pathname === '/myfiles' ||
      props.location.pathname === '/myfiles/details' ||
      props.location.pathname === '/myDocuments' ||
      props.location.pathname === '/myDocuments/details' ||
      props.location.pathname === '/publishedpolicies' ||
      props.location.pathname === '/deleted-documents' ||
      props.location.pathname.includes('/reference/') ||
      routeAccess?.hasHeader
   ) {
      // let pathname =
      //     sessionStorage.getItem("userRole") === "user"
      //         ? "/dashboard"
      //         : "/dashboard";
      let pathExists = props.location.pathname !== '/documents/editor' ? true : false;
      return (
         // <section className="header header-a">
         //    <div className="container-fluid">
         // {props.location.pathname === '/dashboard' && sessionStorage.getItem('userRole') !== 'user' ? (
         //    String(active_subs) === String(false) && !dismiss_subs ? (
         //       <div className="top-pop">
         //          <span>You do not currently have an active subscription, please subscribe </span>
         //          <span>
         //             <button onClick={(e) => redirect_to(e)}>Here</button>
         //          </span>
         //          <span>
         //             <button onClick={(e) => dismiss_subsfun(e)}>Dismiss</button>
         //          </span>
         //       </div>
         //    ) : Number(Comp_details) < Number(13) && !dismiss_comp_details ? (
         //       <div className="top-pop">
         //          <span>Please complete your organisation details to customise your documents </span>
         //          <span>
         //             <button onClick={() => myProfilefun('companydetail')}>Continue</button>{' '}
         //          </span>
         //          <span>
         //             <button onClick={(e) => dismiss(e)}>Dismiss</button>{' '}
         //          </span>
         //       </div>
         //    ) : null
         // ) : null}
         //       <div className="header-sec header-fixed">
         //          {pathExists && (
         //             <div className="loging-sec head-common">
         //                <IconButton aria-label="notification" onClick={() => props.history.push('/knowledge')}>
         //                   <Badge>
         //                      <HelpOutlineIcon />
         //                   </Badge>
         //                </IconButton>
         //                <IconButton aria-label="notification" onClick={() => notification()}>
         //                   <Badge badgeContent={unReadCount}>
         //                      <NotificationsNoneIcon />
         //                   </Badge>
         //                </IconButton>
         //                <Dropdown isOpen={dropdownOpen} toggle={() => profileToggle()} className='profile-dropdown'>
         //                   <DropdownToggle tag="div" className="profile-img" data-toggle={dropdownOpen}>
         //                      {displayName}
         //                   </DropdownToggle>
         //                   {dropdownOpen === true ? (
         //                      <DropdownMenu>
         //                         <div className="inner_head_sec">
         //                            <div className="inner_heads">
         //                               <div className="cancel_headsec">
         //                                  <span className="drop-profile">
         //                                     <div className="profile-img">{displayName}</div>
         //                                     <span className="drop-user">
         //                                        <span>{longName}</span>
         //                                        <span className="drop-email">{myProfile.email ? myProfile.email : null}</span>
         //                                     </span>
         //                                  </span>
         //                                  <a className="list_items" onClick={(e) => myProfilefun('myprofile')}>
         //                                     My Profile
         //                                  </a>
         //                                  {/* {String(active_subs) !== String(false) ? (
         //                                     sessionStorage.getItem('userRole') === 'user' ? (
         //                                        user_permission.filter((e) => String(e.name) === String('Settings') || String(e.name) === String('Settings'))
         //                                           .length > 0 ? (
         //                                           <div className="navbar-dropdown" style={{ width: '100%' }}>
         //                                              <div className="nested navbar-item dropdown">
         //                                                 <div className="dropdown-trigger">
         //                                                    <a className="button list_items" aria-haspopup="true" aria-controls="dropdown-menu">
         //                                                       <span className="icon-show">Settings</span>
         //                                                    </a>
         //                                                 </div>
         //                                                 <div className="dropdown-menu" id="dropdown-menu" role="menu">
         //                                                    <div className="dropdown-content">
         //                                                       <a onClick={() => myProfilefun('companydetail')} className="dropdown-item list_items">
         //                                                          Organisation Details
         //                                                       </a>
         //                                                       <a className="dropdown-item list_items" onClick={(e) => company_settings()}>
         //                                                          Other Settings
         //                                                       </a>
         //                                                    </div>
         //                                                 </div>
         //                                              </div>
         //                                           </div>
         //                                        ) : null
         //                                     ) : (
         //                                        <div className="navbar-dropdown" style={{ width: '100%' }}>
         //                                           <div className="nested navbar-item dropdown">
         //                                              <div className="dropdown-trigger">
         //                                                 <a className="button list_items" aria-haspopup="true" aria-controls="dropdown-menu">
         //                                                    <span className="icon-show">Settings</span>
         //                                                 </a>
         //                                              </div>
         //                                              <div className="dropdown-menu" id="dropdown-menu" role="menu">
         //                                                 <div className="dropdown-content">
         //                                                    <a onClick={() => myProfilefun('companydetail')} className="dropdown-item list_items">
         //                                                       Organisation Details
         //                                                    </a>
         //                                                    <a className="dropdown-item list_items" onClick={(e) => company_settings()}>
         //                                                       System Settings
         //                                                    </a>
         //                                                 </div>
         //                                              </div>
         //                                           </div>
         //                                        </div>
         //                                     )
         //                                  ) : null} */}
         //                                  {/* {sessionStorage.getItem('userRole') === 'user' ? (
         //                                     user_permission.filter(
         //                                        (e) => String(e.name) === String('Subscriptions') || String(e.name) === String('Subscriptions'),
         //                                     ).length > 0 ? (
         //                                        <a className="list_items" onClick={(e) => subscriptionList()}>
         //                                           Subscription
         //                                        </a>
         //                                     ) : null
         //                                  ) : (
         //                                     <a className="list_items" onClick={(e) => subscriptionList()}>
         //                                        Subscription
         //                                     </a>
         //                                  )} */}
         //                                  {/* <a className="list_items" onClick={(e) => subscriptionList()}>Subscription</a> */}
         //                                  {/* {sessionStorage.getItem('userRole') === 'company' &&
         //                                  myProfile &&
         //                                  myProfile.settings &&
         //                                  myProfile.settings.showPoliciesonSite &&
         //                                  ((myProfile.comboPackage && myProfile.comboPackage.status === 1) ||
         //                                     (myProfile.documentManagement && myProfile.documentManagement.status === 1) ||
         //                                     (myProfile.documentUpdate && myProfile.documentUpdate.status === 1) ||
         //                                     (myProfile.proPackage && myProfile.proPackage.status === 1)) ? (
         //                                     <a className="list_items" onClick={(e) => gotoPublicDocument()}>
         //                                        Public Documents
         //                                     </a>
         //                                  ) : null} */}
         //                                  {String(active_subs) !== String(false) &&
         //                                     docUpdateStatus &&
         //                                     docUpdateStatus === 'active' &&
         //                                     licenseStatus &&
         //                                     licenseStatus === 'active' ? (
         //                                     <a className="list_items" onClick={() => restore_modal_view()}>
         //                                        Restore All
         //                                     </a>
         //                                  ) : null}
         //                                  <a className="logout-menu" onClick={() => dispatch(logOut(props.history))}>
         //                                     Logout
         //                                  </a>
         //                               </div>
         //                            </div>
         //                         </div>
         //                      </DropdownMenu>
         //                   ) : (
         //                      <DropdownMenu>
         //                         <div className="inner_head_sec">
         //                            <div className="inner_heads">
         //                               <div className="cancel_headsec">
         //                                  <span className="drop-profile">
         //                                     <div className="profile-img">{displayName}</div>
         //                                     <span className="drop-user">
         //                                        <span>{longName}</span>
         //                                        <span className="drop-email">{myProfile.email ? myProfile.email : null}</span>
         //                                     </span>
         //                                  </span>
         //                               </div>
         //                            </div>
         //                         </div>
         //                      </DropdownMenu>
         //                   )}
         //                </Dropdown>
         //                {/* <Dropdown isOpen={dropdownOpen}>
         //                            <DropdownToggle tag="div" className="profile-img" data-toggle={dropdownOpen}										>
         //                                {displayName}
         //                            </DropdownToggle>
         //                            <DropdownMenu>
         //                                <div className="inner_head_sec">
         //                                    <div className="inner_heads">
         //                                        <div className="cancel_headsec">
         //                                            <span className="drop-profile">
         //                                                <div className="profile-img">{displayName}</div>
         //                                                <span className="drop-user">
         //                                                    <span>{longName}</span>
         //                                                    <span className="drop-email">
         //                                                        {myProfile.email ? myProfile.email : null}
         //                                                    </span>
         //                                                </span>
         //                                            </span>
         //                                            <a className="list_items" onClick={(e) => myProfilefun("myprofile")}>My Profile</a>
         //                                            {String(active_subs) !== String(false) ?
         //                                                (sessionStorage.getItem('userRole') === 'user') ? (
         //                                                    (user_permission.filter(e => String(e.name) === String('Settings') || String(e.name) === String('Settings')).length > 0) ?
         //                                                        <div className="navbar-dropdown" style={{ width: "100%" }}>
         //                                                            <div className="nested navbar-item dropdown">
         //                                                                <div className="dropdown-trigger">
         //                                                                    <a className="button list_items" aria-haspopup="true" aria-controls="dropdown-menu">
         //                                                                        <span className="icon-show">Settings</span>
         //                                                                    </a>
         //                                                                </div>
         //                                                                <div className="dropdown-menu" id="dropdown-menu" role="menu">
         //                                                                    <div className="dropdown-content">
         //                                                                        <a onClick={() => myProfilefun("companydetail")} className="dropdown-item list_items">Organisation Details</a>
         //                                                                        <a className="dropdown-item list_items" onClick={(e) => company_settings()}>Other Settings</a>
         //                                                                    </div>
         //                                                                </div>
         //                                                            </div>
         //                                                        </div>
         //                                                        : null
         //                                                ) : <div className="navbar-dropdown" style={{ width: "100%" }}>
         //                                                    <div className="nested navbar-item dropdown">
         //                                                        <div className="dropdown-trigger">
         //                                                            <a className="button list_items" aria-haspopup="true" aria-controls="dropdown-menu">
         //                                                                <span className="icon-show">Settings</span>
         //                                                            </a>
         //                                                        </div>
         //                                                        <div className="dropdown-menu" id="dropdown-menu" role="menu">
         //                                                            <div className="dropdown-content">
         //                                                                <a onClick={() => myProfilefun("companydetail")} className="dropdown-item list_items">Organisation Details</a>
         //                                                                <a className="dropdown-item list_items" onClick={(e) => company_settings()}>Other Settings</a>
         //                                                            </div>
         //                                                        </div>
         //                                                    </div>
         //                                                </div>
         //                                                : null}
         //                                            {(sessionStorage.getItem('userRole') === 'user')
         //                                                ? (user_permission.filter(e => String(e.name) === String('Subscriptions') || String(e.name) === String('Subscriptions')).length > 0)
         //                                                    ? <a className="list_items" onClick={(e) => subscriptionList()}>Subscription</a>
         //                                                    : null
         //                                                : <a className="list_items" onClick={(e) => subscriptionList()}>Subscription</a>}

         //                                            {(sessionStorage.getItem('userRole') === 'company' && myProfile && myProfile.settings && myProfile.settings.showPoliciesonSite)
         //                                                ? <a className="list_items" onClick={(e) => props.history.push('/published/policies')}>Public Documents</a>
         //                                                : null}
         //                                            {String(active_subs) !== String(false) && docUpdateStatus && docUpdateStatus === 'active'
         //                                                ? <a className="list_items" onClick={() => restore_modal_view()}>Restore All</a>
         //                                                : null}
         //                                            <a className="logout-menu" onClick={() => dispatch(logOut(props.history))}>Logout</a>
         //                                        </div>
         //                                    </div>
         //                                </div>
         //                            </DropdownMenu>
         //                        </Dropdown> */}
         //             </div>
         //          )}
         //       </div>
         //    </div>
         //    {/* {showMsg ?
         //            <ReactstrapModal isOpen={showMsg} className='sub-expiry-modal'>
         //                <ModalBody>
         //                    <p>Your subscription is not valid</p>
         //                    <span><img src="/assets/images/new-ui/subscription.svg" /></span>
         //                    <p className='d-a-btn'>
         //                        <button className='d-a-btn-update' onClick={() => history.push({ pathname: '/subscriptions', state: { active_tab: '2' } })}>Subscribe Now</button>
         //                    </p>
         //                </ModalBody>
         //            </ReactstrapModal> : null} */}

         //    {showRestoreModal && <RestoreModal history={props.history} restoreFunction={onRestoreAllDocuments} />}
         //    {pop_show_hide && <BottomModal history={props.history} />}
         //    {showNotification && <NotificationModal history={props.history} />}
         //    {showOneNotification && <OneNotificationModal />}
         //    {subdomainRemindModal && <SubdomainRemind history={props.history} />}
         // </section>

         <section className="caredaily-header">
            <div className={`caredaily-header-container ${sidebarCollapsed ? 'right-collapsed' : ''}`}>
               {/* Alert Banners */}
               {/* {props.location.pathname === '/dashboard' && sessionStorage.getItem('userRole') !== 'user' && (
                  <>
                     {String(active_subs) === String(false) && !dismiss_subs && (
                        <div className="caredaily-alert-banner caredaily-alert-warning">
                           <div className="caredaily-alert-content">
                              <span className="caredaily-alert-message">
                                 You do not currently have an active subscription, please subscribe
                              </span>
                              <div className="caredaily-alert-actions">
                                 <button className="caredaily-alert-btn caredaily-alert-btn-primary" onClick={(e) => redirect_to(e)}>
                                    Subscribe Here
                                 </button>
                                 <button className="caredaily-alert-btn caredaily-alert-btn-secondary" onClick={(e) => dismiss_subsfun(e)}>
                                    Dismiss
                                 </button>
                              </div>
                           </div>
                        </div>
                     )}

                     {Number(Comp_details) < Number(13) && !dismiss_comp_details && String(active_subs) !== String(false) && (
                        <div className="caredaily-alert-banner caredaily-alert-info">
                           <div className="caredaily-alert-content">
                              <span className="caredaily-alert-message">
                                 Please complete your organisation details to customise your documents
                              </span>
                              <div className="caredaily-alert-actions">
                                 <button className="caredaily-alert-btn caredaily-alert-btn-primary" onClick={() => myProfilefun('companydetail')}>
                                    Continue
                                 </button>
                                 <button className="caredaily-alert-btn caredaily-alert-btn-secondary" onClick={(e) => dismiss(e)}>
                                    Dismiss
                                 </button>
                              </div>
                           </div>
                        </div>
                     )}
                  </>
               )} */}

               {/* {settingsData && settingsData.Trailstatus === 1 && 
          <TrialBanner trialDays={settingsData?.trialDays}
          daysRemaining={days}
          
         />
         } */}

               {showTrialBanner && (
                  <TrialBanner
                     trialDays={parseInt(trialDays) || 15}
                     daysRemaining={days}
                     isTrialActive={hasActiveTrial}
                     onUpgrade={() => props.history.push('/subscriptions')}
                  />
               )}

               {props.location.pathname === '/dashboard' && sessionStorage.getItem('userRole') !== 'user' ? (
                  String(active_subs) === String(false) && !dismiss_subs ? (
                     <div className="top-pop">
                        <span>
                           <svg width={20} height={20} color="#00bfa5" viewBox="0 0 20 20" fill="currentColor">
                              <path
                                 fill-rule="evenodd"
                                 d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                 clip-rule="evenodd"
                              />
                           </svg>
                           You do not currently have an active subscription, please subscribe{' '}
                        </span>
                        <div>
                           <button onClick={(e) => redirect_to(e)}>Here</button>
                           <button onClick={(e) => dismiss_subsfun(e)}>Dismiss</button>
                        </div>
                     </div>
                  ) : // <div class="subscription-required-overlay">
                  //    <div class="subscription-required-modal">

                  //       <div class="subscription-required-header">
                  //          <div class="subscription-required-icon">
                  //             <svg width="32" height="32" viewBox="0 0 20 20" fill="currentColor">
                  //                <path fill-rule="evenodd"
                  //                   d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  //                   clip-rule="evenodd" />
                  //             </svg>
                  //          </div>
                  //          <h2>Subscription Required</h2>
                  //       </div>

                  //       <p class="subscription-required-text">
                  //          You do not currently have an active subscription. Please subscribe to continue enjoying
                  //          our premium features and services.
                  //       </p>

                  //       <div class="subscription-required-features">
                  //          <div class="feature-item">
                  //             <span class="dot"></span>
                  //             Unlimited access to all features
                  //          </div>
                  //          <div class="feature-item">
                  //             <span class="dot"></span>
                  //             Priority customer support
                  //          </div>
                  //          <div class="feature-item">
                  //             <span class="dot"></span>
                  //             Cancel anytime, no commitment
                  //          </div>
                  //       </div>

                  //       <button
                  //          class="subscription-required-btn"
                  //          onClick={(e) => redirect_to(e)}
                  //       >
                  //          Subscribe Now
                  //       </button>

                  //       <p class="subscription-required-footer">
                  //          By subscribing, you agree to our Terms of Service and Privacy Policy.
                  //       </p>

                  //    </div>
                  // </div>
                  Number(Comp_details) < Number(13) && !dismiss_comp_details ? (
                     <div className="top-pop">
                        <span>
                           <svg width={20} height={20} color="#00bfa5" viewBox="0 0 20 20" fill="currentColor">
                              <path
                                 fill-rule="evenodd"
                                 d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                 clip-rule="evenodd"
                              />
                           </svg>
                           Please complete your organisation details to customise your documents{' '}
                        </span>
                        <div>
                           <button onClick={() => myProfilefun('companydetail')}>Continue</button> <button onClick={(e) => dismiss(e)}>Dismiss</button>{' '}
                        </div>
                     </div>
                  ) : null
               ) : null}

               {/* Main Header */}
               <div className="caredaily-header-main">
                  <div className="caredaily-header-left">
                     {/* Logo */}

                     <div className="caredaily-logo-text">
                        {/* {props.location.pathname.split('/')[1]?.toUpperCase()} */}
                        {props.location.pathname
                           .split('/')[1]
                           ?.split(/[-_]/)
                           .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                           .join(' ')}
                     </div>

                     {/* <div className="caredaily-logo" onClick={() => props.history.push('/dashboard')}>
                        <div className="caredaily-logo-icon">
                           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                           </svg>
                        </div>
                        <span className="caredaily-logo-text">Care Daily</span>
                     </div> */}
                  </div>

                  <div className="caredaily-header-right">
                     {/* Location/Branch Selector */}
                     <div className="caredaily-location-selector" onClick={toggleLocationDropdown}>
                        <span className="caredaily-location-icon">
                           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                              <circle cx="12" cy="10" r="3"></circle>
                           </svg>
                        </span>
                        <span className="caredaily-location-name">{selectedLocation.name}</span>
                        {/* <span className="caredaily-location-badge">{selectedLocation.badge}</span> */}

                        {/* Location Dropdown */}
                        <div className={`caredaily-location-dropdown ${sidebarCollapsed ? '' : locationDropdownOpen ? 'toselect' : ''}`}>
                           {branches.map((location) => (
                              <div
                                 key={location._id}
                                 className={`caredaily-location-option ${selectedLocation.id === location._id ? 'selected' : ''}`}
                                 onClick={(e) => {
                                    e.stopPropagation();
                                    selectLocation(location);
                                 }}
                              >
                                 <div className="caredaily-location-info">
                                    <div className="caredaily-location-option-name">{location.name}</div>
                                 </div>
                                 {/* <div className="caredaily-location-stats">
                                    <span>{location.clients} clients</span>
                                    <span>{location.staff} staff</span>
                                 </div> */}
                              </div>
                           ))}
                        </div>
                     </div>
                     {/* Help/Knowledge Base */}
                     <IconButton className="caredaily-icon-btn" aria-label="knowledge base" onClick={() => props.history.push('/knowledge')}>
                        <HelpOutlineIcon />
                     </IconButton>

                     {/* Notifications */}
                     <IconButton className="caredaily-icon-btn" aria-label="notifications" onClick={() => notification()}>
                        <NotificationsNoneIcon />
                     </IconButton>

                     {/* User Profile Dropdown */}
                     {/* <div className="caredaily-user-dropdown">
                        <Dropdown isOpen={dropdownOpen} toggle={() => profileToggle()} className="caredaily-profile-dropdown">
                           <DropdownToggle tag="div" className="caredaily-user-profile" data-toggle={dropdownOpen}>
                              <div className="caredaily-user-avatar">{displayName}</div>
                              <svg
                                 width="14"
                                 height="14"
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth="2"
                                 className="caredaily-dropdown-arrow"
                              >
                                 <polyline points="6 9 12 15 18 9"></polyline>
                              </svg>
                           </DropdownToggle>

                           <DropdownMenu className="caredaily-dropdown-menu">
           
                              <div className="caredaily-dropdown-header">
                                 <div className="caredaily-user-avatar caredaily-user-avatar-large">{displayName}</div>
                                 <div className="caredaily-user-info">
                                    <div className="caredaily-user-fullname">{longName}</div>
                                    <div className="caredaily-user-email">{myProfile.email || ''}</div>
                                 </div>
                              </div>

                              <div className="caredaily-dropdown-divider"></div>

                          
                              <a className="caredaily-dropdown-item" onClick={() => myProfilefun('myprofile')}>
                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                 </svg>
                                 My Profile
                              </a>

                       
                              {String(active_subs) !== String(false) && (
                                 <div className="caredaily-dropdown-submenu">
                                    <div className="caredaily-dropdown-item caredaily-submenu-trigger">
                                       <div className="caredaily-submenu-label">
                                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                             <circle cx="12" cy="12" r="3"></circle>
                                             <path d="M12 1v6m0 6v6m-8-7h6m6 0h6"></path>
                                          </svg>
                                          Settings
                                       </div>
                                       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="caredaily-submenu-arrow">
                                          <polyline points="9 18 15 12 9 6"></polyline>
                                       </svg>
                                    </div>

                                    <div className="caredaily-submenu-items">
                                       <a className="caredaily-dropdown-item caredaily-dropdown-item-nested" onClick={() => myProfilefun('companydetail')}>
                                          Organisation Details
                                       </a>
                                       <a className="caredaily-dropdown-item caredaily-dropdown-item-nested" onClick={() => company_settings()}>
                                          System Settings
                                       </a>
                                    </div>
                                 </div>
                              )}

                              <a className="caredaily-dropdown-item" onClick={() => subscriptionList()}>
                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                 </svg>
                                 Subscription
                              </a>

                              {sessionStorage.getItem('userRole') === 'company' &&
                                 myProfile?.settings?.showPoliciesonSite && (
                                    <a className="caredaily-dropdown-item" onClick={() => gotoPublicDocument()}>
                                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                          <polyline points="14 2 14 8 20 8"></polyline>
                                       </svg>
                                       Public Documents
                                    </a>
                                 )}

                              {String(active_subs) !== String(false) &&
                                 docUpdateStatus === 'active' &&
                                 licenseStatus === 'active' && (
                                    <a className="caredaily-dropdown-item" onClick={() => restore_modal_view()}>
                                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                          <polyline points="23 4 23 10 17 10"></polyline>
                                          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                                       </svg>
                                       Restore All
                                    </a>
                                 )}

                              <div className="caredaily-dropdown-divider"></div>

                         
                              <a className="caredaily-dropdown-item caredaily-dropdown-item-logout" onClick={() => dispatch(logOut(props.history))}>
                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                    <polyline points="16 17 21 12 16 7"></polyline>
                                    <line x1="21" y1="12" x2="9" y2="12"></line>
                                 </svg>
                                 Logout
                              </a>
                           </DropdownMenu>
                        </Dropdown>
                     </div> */}
                  </div>
               </div>
            </div>

            {/* Modals */}
            {showRestoreModal && <RestoreModal history={props.history} restoreFunction={onRestoreAllDocuments} />}
            {pop_show_hide && <BottomModal history={props.history} />}
            {showNotification && <NotificationModal history={props.history} />}
            {showOneNotification && <OneNotificationModal />}
            {subdomainRemindModal && <SubdomainRemind history={props.history} />}
         </section>
      );
   } else {
      return null;
   }
};

const ResendCounter = ({ initialCount = 0, render = () => {}, start = false, interval = 60000, onStop = () => {} }) => {
   const [count, setCount] = useState(initialCount);
   let intervalRef;

   useEffect(() => {
      if (!start) return;
      intervalRef = setInterval(() => {
         if (count <= 0) {
            setCount(initialCount);
            onStop(false);
         }
         setCount((c) => c - 1);
      }, interval);

      return () => {
         clearInterval(intervalRef);
      };
   }, [start, count]);

   return render ? render({ count }) : count;
};

export default Header;
